// extracted by mini-css-extract-plugin
export var contentBody = "_b1-9";
export var headerImage = "_b1-2";
export var imageButton = "_b1-7";
export var imageButtonIcon = "_b1-8";
export var imageHeader = "_b1-4";
export var imageHeaderText = "_b1-5";
export var imageOverlay = "_b1-3";
export var imageTitle = "_b1-6";
export var imageWrapper = "_b1-1";
export var taskList = "_b1-a";
export var widget = "_b1-0";